import React, { SyntheticEvent } from "react";
import Select from 'react-select'
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import QuoteStepBase from '../../components/QuoteStepBase'
import ButtonContinue from "../../components/ButtonContinue";
import ValidatableSelect from "../../components/ValidatableSelect";
import { ValidatableForm } from "../../components/ValidatableForm"
import { IQuoteStepState, IDriverStepProps } from "../../components/interfaces";
import { IAppState } from "../../state/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { PATHS, FULL_QUOTE_STEPS } from "../../AppConstants";
import { validationUtils } from "../../validation/Validation";
import { quoteStepChanged } from "../../state/appActions";
import Utilities from "../../classes/Utilities";
import { reRateQuote, disputeViolations } from "../../state/fullQuoteActions";
import { Alert } from 'react-bootstrap'
import { IViolation } from "../../classes/ExternalQuote";
import { IListOption } from "../../classes/Domain";
import * as _ from 'lodash';

interface IState extends IQuoteStepState {
    deniedViolations: Array<IViolation>,
    disputeAccidents: Array<IViolation>,
    updateDriverInfo: boolean,
    initiated: boolean,
    acceptViolations: boolean,
    //accidentErrors: any | null;
}

interface IProps extends IDriverStepProps {
    quoteId: number,
    paymentPlanCode: number,
    driverViolationsGroupIndex: number,
    driversViolationsGroupCount: number,
    driverViolations: Array<IViolation>,
    driverAccidents: Array<IViolation>,
    mvrStatus: string,
    reRateQuote: (quoteId: number, paymentPlanCode: number) => Promise<any>,
    disputeViolations: (quoteId: number, driverId: number, violationsForDispute: Array<IViolation>) => Promise<any>
}

class Violations extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.handleAcceptChange = this.handleAcceptChange.bind(this);
        this.handleViolationChange = this.handleViolationChange.bind(this);
        
        this.state = {
            deniedViolations: [],
            disputeAccidents: [],
            acceptViolations: true,
            initiated: false,
            updateDriverInfo: false,
            updatingStore: false,
            errors: null
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.initiated) {
            const disputeAccidents = _.filter(nextProps.driverAccidents, (a) => a.allowedDispute);
            const nextState = {
                ...prevState,
                disputeAccidents,
                initiated : true
            };

            return nextState;
        }

        return prevState;
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        validationUtils.subscribeToValidationFailure("VIOLATIONS",
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure("VIOLATIONS");
    }

    next() {
        var nextUrl = this.getNextUrl();

        this.setState({ updatingStore: true }, () => {
            let promise;

            if (0 < this.state.disputeAccidents.length) {
                console.log("there are accidents for dispute");
                promise = this.props
                    .disputeViolations(this.props.quoteId, this.props.driver.id, this.state.disputeAccidents);
                promise.then(() => {
                    console.log("accidents disputed, goto " + nextUrl);
                });
            }
            else {
                console.log("no accidents, no disput needed, goto " + nextUrl);
                promise = Promise.resolve();
            }

            promise.then(
                () => {
                    if (this.props.driverViolationsGroupIndex === this.props.driversViolationsGroupCount - 1) {
                        this.props.reRateQuote(this.props.quoteId, this.props.paymentPlanCode)
                            .then(() => {
                                this.props.history.push(nextUrl);
                            });;
                    } else {
                        this.props.history.push(nextUrl);
                    }
                },
                () => this.setState({ ...this.state, updatingStore: false })
            );
        });
    }

    getNextUrl() {
        return this.props.driverViolationsGroupIndex < this.props.driversViolationsGroupCount - 1
            ? Utilities.formatUrl(PATHS.FQ_VIOLATIONS, (this.props.driverViolationsGroupIndex + 1).toString())
            : PATHS.FQ_POLICY_DETAILS;
    }

    handleAcceptChange(event: SyntheticEvent) {
        var acceptViolations = this.state.acceptViolations;
        var updateDriverInfo = this.state.updateDriverInfo;

        acceptViolations = !acceptViolations;
        updateDriverInfo = !updateDriverInfo;

        this.setState({ ...this.state, acceptViolations, updateDriverInfo })
    }

    handleViolationChange(violation: IViolation) {
        var deniedViolations = [...this.state.deniedViolations];
        for (var i = 0; i < deniedViolations.length; i++) {
            if (deniedViolations[i].id === violation.id) {
                deniedViolations.splice(i, 1);
                this.setState({ ...this.state, deniedViolations, acceptViolations: 0 === deniedViolations.length || this.state.updateDriverInfo });
                return;
            }
        }

        deniedViolations.push(violation);
        this.setState({ ...this.state, deniedViolations, acceptViolations: 0 === deniedViolations.length || this.state.updateDriverInfo });
    }

    handleAccidentChange(accident: IViolation, selectedOption: string | null) {
        accident.accDisSet = selectedOption;
        var disputeAccidents = [...this.state.disputeAccidents];

        for (var i = 0; i < disputeAccidents.length; i++) {
            if (disputeAccidents[i].id === accident.id) {
                disputeAccidents[i].accDisSet = accident.accDisSet;
                break;
            }
        }

        this.setState({ ...this.state, disputeAccidents, acceptViolations: !this.anyDisputedAccidents(disputeAccidents) || this.state.updateDriverInfo });
    }

    getSelectedDisputeOption(accDisSet: string, disputeOptions: Array<IListOption> | null): IListOption | null {
        if (!disputeOptions) return null;
        const option = _.find(disputeOptions, (o) => o.value === accDisSet);
        return !option ? null : option;
    }

    hasAccidentValidationError(accidentId: number): boolean {
        return this.state.errors && this.state.errors[accidentId];
    }

    getAccidentValidationError(accidentId: number): string {
        if (!this.state.errors || !this.state.errors[accidentId]) return "";
        return this.state.errors[accidentId]["accDisSet"][0];
    }

    anyDisputedAccidents(accidents: Array<IViolation>) {
        return 0 < _.filter(accidents, (a) => !!a.accDisSet).length
    }

    render() {
        return (
            <QuoteStep id="violations" className="">
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea">
                        <h5>Oops! Something changed</h5>
                    </div>
                    <p className="info">The motor vehicle record for {this.props.driver.firstName + " " + this.props.driver.lastName} with the license number ending in {this.props.driver.licenseNumber.substring(this.props.driver.licenseNumber.length - 3)} was returned with the following violations/accidents:</p>
                    <p className="infoBold" dangerouslySetInnerHTML={{ __html: this.props.mvrStatus }}></p>
                    <div className="rate-result">
                        {
                            this.props.driverViolations && 0 < this.props.driverViolations.length
                                ? 
                                <div className="payment-choice" key={Utilities.uniqueId()}>
                                    <div className="term">
                                        <div className="term-name">Violations</div>
                                    </div>
                                    {this.props.driverViolations.map((violation, i) => (
                                        <div key={Utilities.uniqueId()} className={i === this.props.driverViolations.length - 1 ? "item no-border" : "item"}>
                                            <label className="left-cell"><strong>{violation.date}</strong></label>
                                            <label className="right-cell">{violation.incidentDescription}</label>
                                        </div>
                                    ))}
                                </div>
                                :
                                null
                        }
                        {
                            this.props.driverAccidents
                                ? this.props.driverAccidents.map((accident) => (
                                    <div className="payment-choice accident" key={Utilities.uniqueId()}>
                                        {
                                            accident.allowedDispute
                                                ?
                                                <div className="term">
                                                    <div className="left-cell">Accident Dispute</div>
                                                    <div className="right-cell text-normal">
                                                        <ValidatableSelect
                                                            key={Utilities.uniqueId()}
                                                            options={accident.disputeOptions ?? []}
                                                            value={accident.accDisSet}
                                                            onChange={(v) => { this.handleAccidentChange(accident, v ? v["value"] : null); }}
                                                            className="dispute"
                                                            validated={null !== this.state.errors}
                                                            validationError={validationUtils.getValidationErrorForEntity(accident.id, this.state.errors, "accDisSet")}                                                        />
                                                    </div>
                                                </div>
                                                :
                                                <div className="term">
                                                    <div className="term-name">Accident</div>
                                                </div>
                                        }
                                        <div className="item">
                                            <label className="left-cell"><strong>Description</strong></label>
                                            <label className="right-cell">{accident.incidentDescription}</label>
                                        </div>
                                        <div className="item no-border">
                                            <label className="left-cell"><strong>Date</strong></label>
                                            <label className="right-cell">{accident.date}</label>
                                        </div>
                                    </div>
                                ))
                                : null
                        }
                    </div>

                    {this.anyDisputedAccidents(this.state.disputeAccidents)
                        ?
                        <Alert variant="primary" className="update-driver-info">
                            <div className="item">
                                <div className="left-cell">
                                    Update driver information
                                </div>
                                <div className="right-cell">
                                    <Toggle
                                        id={Utilities.uniqueId()}
                                        defaultChecked={false}
                                        checked={this.state.updateDriverInfo}
                                        disabled={this.state.updatingStore}
                                        onChange={this.handleAcceptChange} />
                                </div>
                            </div>
                        </Alert>
                        : null}

                    <div className="btnContainer">
                        <ButtonContinue
                            label="Continue"
                            disabled={this.state.updatingStore || !this.state.acceptViolations}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverViolationsGroupIndex = !ownProps.match.params["driverViolationsGroupIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverViolationsGroupIndex"], 10);

    const driverId = state.externalQuote?.mvrResult.mvrDriversResults[driverViolationsGroupIndex].driverId;
    const violations = state.externalQuote?.mvrResult.mvrDriversResults[driverViolationsGroupIndex].violations;
    const mvrStatus = state.externalQuote?.mvrResult.mvrDriversResults[driverViolationsGroupIndex].status;
    const driver = _.filter(state.externalQuote?.drivers, (d) => d.id === driverId)[0];

    return {
        quoteId: state.externalQuote?.rtrQuoteId,
        paymentPlanCode: state.externalQuote?.paymentPlanCode,
        driverViolationsGroupIndex,
        driversViolationsGroupCount: state.externalQuote?.mvrResult.mvrDriversResults.length,
        driver: driver,
        driverViolations: _.filter(violations, (v) => !v.isAccident),
        driverAccidents: _.filter(violations, (v) => v.isAccident),
        mvrStatus: mvrStatus
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(FULL_QUOTE_STEPS.FINALIZE)),
        reRateQuote: (quoteId: number, paymentPlanCode: number) => dispatch(reRateQuote(quoteId, paymentPlanCode, true)),
        disputeViolations: (quoteId: number, driverId: number, violationsForDispute: Array<IViolation>) => dispatch(disputeViolations(quoteId, driverId, violationsForDispute)),
    };
};

export default connect(mapProps, mapDispatch)(Violations);
